import { createRouter } from '@tanstack/react-router'

import type { AuthStatus } from '@graphit/types'

import { queryClient } from '~/queryClient'
import { routeTree } from '~/routeTree.gen'

export const router = createRouter({
	routeTree,
	defaultPreload: 'intent',
	scrollRestoration: true,
	context: {
		queryClient,
		auth: undefined! as AuthStatus
	}
})

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}
